import { WebParameterContext, WebResponesContext } from '../../model/common';
declare var app;
export class ServicesPosmForm {
    constructor() {

    }
    public HandleWebParameterContextBeforeDBRequest(webcontext: WebParameterContext): WebParameterContext {
       
        console.log("10085");
        if(webcontext.OpType.toLowerCase()=="add" || webcontext.OpType.toLowerCase()=="edite"){
            let body=JSON.parse(webcontext.RequestBody);
            if(!body.a_IsChoice){//如果没有删除照片
              body.a_Photo="";
            //   body.a_SweepCodeContent="";
            }else{
                if(typeof(body["a_Photo"])=="undefined"){
                  webcontext.ResponseMessage.Success=false;
                  webcontext.ResponseMessage.ErrorMessage="POSM检查必须上传照片";
                }else if(!body.a_Photo){
                    webcontext.ResponseMessage.Success =false;
                    webcontext.ResponseMessage.ErrorMessage ="POSM检查必须上传照片";
                }
                else if( body.a_Photo.toString().trim() == ""){
                  webcontext.ResponseMessage.Success =false;
                  webcontext.ResponseMessage.ErrorMessage ="POSM检查必须上传照片";
                }
            }
           webcontext.RequestBody = JSON.stringify(body);
        }
        return webcontext;
    }
    public HandleServerContextAfterDBRequest(webParameterContext: WebParameterContext, webContext: WebResponesContext): WebResponesContext {
        if(webParameterContext.OpType=="GETEDITE"){
            if(webContext.Status){
                if(webContext.Status){
                    if(webContext.Status.a_IsChoice=="0"){
                        webContext.Status.a_IsChoice=false;
                    }
                }
                if(webContext.Status.a_IsChoice){
                    let dom =document.getElementsByName("a_Photo");
                    if(dom.length>0){
                     dom.forEach((dm,i)=>{
                      document.getElementsByName("a_Photo")[i].style.display="block";
                     });
                    }
                    let dom4 =document.getElementsByName("a_SweepCodeContent");
                    if(dom4.length>0){
                        dom4.forEach((dm,i)=>{
                      document.getElementsByName("a_SweepCodeContent")[i].style.display="block";
                     });
                    }
                    
                }else{
                    let dom =document.getElementsByName("a_Photo");
                    if(dom.length>0){
                     dom.forEach((dm,i)=>{
                      document.getElementsByName("a_Photo")[i].style.display="none";
                     });
                    }
                    let dom4 =document.getElementsByName("a_SweepCodeContent");
                    if(dom4.length>0){
                        dom4.forEach((dm,i)=>{
                      document.getElementsByName("a_SweepCodeContent")[i].style.display="none";
                     });
                    }
                }
            }
             

        }
        return webContext;
    }
}